import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/auth/services/authentication.service';
import { RouterService } from '@app/routing/router.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'portal-redir-routing',
  templateUrl: './redir-routing.component.html',
  standalone: false,
})
export class RedirRoutingComponent implements OnInit {
  constructor(
    private location: Location,
    private routerService: RouterService,
    private authService: AuthenticationService
  ) {}

  ngOnInit() {
    // handling possible `redir/...` location
    // backend might produce location such as `/redir/enterprises/bb.neotel/users/420%40site1.bb.neotel`
    // or `/redir/enterprises/bb.neotel`
    const path = this.location.path(true);
    if (path.startsWith('/redir/enterprises')) {
      this.authService.authUser$.pipe(take(1)).subscribe((authUser) => {
        this.routerService.navigateByUrl(
          path.replace('redir/', `reseller/${authUser.serviceProviderName}/`),
          {
            replaceUrl: true,
          }
        );
      });
    } else {
      this.routerService.navigateToInitialRoute();
    }
  }
}
